// libraries
import { clsx } from "clsx";
import { forwardRef } from "react";

// layouts
import { PageInterface } from "./page";
import { PageFrame } from "./PageFrame";
import TopNav from "./PageTopNav";

const DefaultLayout = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<PageInterface> & React.HTMLAttributes<HTMLDivElement>
>(function DefaultLayout(
  { children, afterNavComponent, className, print, ...rest },
  ref,
) {
  return (
    <PageFrame
      header={<TopNav />}
      ref={ref}
      print={print}
      {...rest}
      className={clsx(
        "main-container [--page-content-padding:24px] ml-auto mr-auto [max-width:var(--container-width)] [flex-grow:1] [padding-left:24px] [padding-right:24px] [overflow-x:hidden] [background:var(--color-background-default)] [@media(max-width:_780px)]:[--page-content-padding:16px] [@media(max-width:_780px)]:[padding-left:16px] [@media(max-width:_780px)]:[padding-right:16px] mt-[var(--nav-height)]",
        "[&.profile-container]:[max-width:900px]",
        className,
      )}
    >
      {children}
    </PageFrame>
  );
});

export default DefaultLayout;
